import script from "./OTabelaProfissionais.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTabelaProfissionais.vue?vue&type=script&lang=ts&setup=true"

import "./OTabelaProfissionais.vue?vue&type=style&index=0&id=57863841&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57863841"]])

export default __exports__